import SectorService from '../../services/Sector.js';

if($('#create-network-group-component').length){
    var app = new Vue({
        el: '#create-network-group-component',
        data: {
            defaultImage: 'https://cdn.leadingedgeonly.com/files/platform-images/Mkv33n8JMlxhU413WbL0o7tzA8lp2gsU3xRuQEkp-card.jpg',
            networkGroup:{
                name:'',
                strapline:'',
                description:'Please add a description',
                colour:'#FF6965',
                sector_id:'',
                private:'',
                image_location_file:'',
                image_location:'https://cdn.leadingedgeonly.com/files/platform-images/Mkv33n8JMlxhU413WbL0o7tzA8lp2gsU3xRuQEkp-card.jpg',
                header_banner_image_file:'',
                header_banner_image:'https://'+awsUrl+'/25/D3lcLGDuVhF7pvqqxvozuZSwvgMMoT4Pg5ErFSl3.jpg',
                background: 'Please add a background'
            },
            account:{
                account_type:{}
            },
            loadingMessage:'Loading organisation creator',
            selectedSector: null,
            loading:true,
            uploaderErrors:[],
            sectors:[],
            showUploadMedia: false,
            dataImages: [],
            targetId: '',
            imageMedia: false
        },
        methods: {
            getAccountByUser(){
                axios.get('/api/v1/account/current-user')
                .then((response) =>  {
                    this.account = response.data;
                    if(this.account.account_type.can_create_private_organisations && this.account.account_type.can_create_public_organisations){
                        this.networkGroup.private = '';
                    }else if(this.account.account_type.can_create_private_organisations){
                        this.networkGroup.private = 1;
                    }else{
                        this.networkGroup.private = 0;
                    }
                    this.loading = false;
                })
                .catch((error) =>  {
                    if(error.response){
                        this.$toasted.error(error.response.data);
                    }
                    this.loading = false;
                })
            },
            createNetwork(){
                if(this.validate()){
                    var form =  document.getElementById('editor-form');
                    var formData = new FormData(form);
                    formData = this.appendFields(formData);
                    this.loading = true;
                    this.loadingMessage = 'Creating organisation';

                    if ((!this.networkGroup.id && !this.networkGroup.image_location_file) || this.imageMedia === true) {
                        formData.append('image_location', this.networkGroup.image_location.replace("//" + this.awsUrl + "/", ""));
                        this.imageMedia = false;
                    } else if (this.networkGroup.image_location_file) {
                        formData.append('image_location', this.networkGroup.image_location_file);
                    }

                    axios.post('/api/v1/network-group', formData)
                    .then((response) =>  {
                        window.location.replace('/organisation/'+response.data.slug+'/edit');
                    })
                    .catch((error) =>  {
                        this.errorHandler(error)
                    });
                }
            },
            errorHandler(error){
                if(typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    let errors = error.response.data.errors;
                    if (errors) {
                        for (let field of Object.keys(errors)) {
                            this.$toasted.error(errors[field][0]);
                        }
                    }
                }
                this.loading = false;
            },
            sectorChange(){
                var sectorID = this.networkGroup.sector_id;
                var sector = this.sectors.filter(obj => {
                    return obj.id === sectorID;
                });
                this.selectedSector = sector[0];
                if(!this.networkGroup.id && !this.networkGroup.header_banner_image_file){
                    this.networkGroup.header_banner_image = sector[0].image_location;
                }
            },
            getSectorSlug(){
                var sectorID = this.networkGroup.sector_id;
                var sector = this.sectors.filter(obj => {
                    return obj.id === sectorID;
                });
                return sector[0].slug;
            },
            previewLogoImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.networkGroup.image_location = fileBlob;
                    this.networkGroup.image_location_file = file;
                    this.showUploadMedia = false;
                }
            },
            appendFields(formData) {
                formData.append('name', this.networkGroup.name);
                formData.append('strapline', this.networkGroup.strapline);
                formData.append('description', this.networkGroup.description);
                formData.append('sector_id', this.networkGroup.sector_id);
                formData.append('colour', this.networkGroup.colour);
                formData.append('header_banner_image_url', this.networkGroup.header_banner_image);
                formData.append('background', this.networkGroup.background);
                return formData;
            },
            validate(){
                let networkGroup = this.networkGroup;

                if(!networkGroup.name){
                    this.$toasted.error('Your organisation must have a Name');
                    return false;
                }

                if(!networkGroup.strapline){
                    this.$toasted.error('Your organisation must have a Strapline');
                    return false;
                }

                if(!networkGroup.sector_id){
                    this.$toasted.error('Your organisation must have a Sector');
                    return false;
                }

                if(this.defaultImage == networkGroup.image_location && !networkGroup.image_location_file){
                    this.$toasted.error('Your organisation must have a Logo');
                    return false;
                }

                return true;
            },
            uploadMedia() {
                this.getUploadedMedia();
                this.targetId = 'image';
                this.showUploadMedia = true;
            },
            getUploadedMedia() {
                axios.get('/api/v1/get-uploaded-media')
                    .then((response) => {
                        if (response.data.hasOwnProperty('uploads')) {
                            this.dataImages = response.data.uploads;
                        }
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
            },
            onSelectImage(data) {
                this.networkGroup.image_location = data.src;
                this.imageMedia = true;
                this.showUploadMedia = false;
            },
            selectMethod(result, files) {
                if (result == 'EXTENSION_ERROR') {
                    this.$toasted.error('The selected files contain invalid extensions.');
                    return;
                } else if (result == 'FILE_SIZE_ERROR') {
                    this.$toasted.error('The selected files size exceeded limit.');
                    return;
                }
                if (files && files[0]) {
                    let file = files[0], vm = this, img = new Image();
                    img.onload = function () {
                        if (this.width > 3000 || this.height > 3000) {
                            vm.$toasted.error('The selected image dimensions exceeded limit (3000*3000).');
                        } else {
                            vm.previewLogoImage(img.src, file);
                        }
                    }
                    img.src = URL.createObjectURL(file);
                }
            }
        },
        mounted () {
            SectorService.getSectors().then(data => {
                this.sectors = data;
            });

            $(".tooltipped").tooltip();

            this.getAccountByUser();
        },
        updated: function () {
        },
        components: {
            'SectorService': SectorService
        },
    });
}